import { createSelector } from '@ngrx/store';

export const commentAndDiagramCommentsLoading = createSelector(
  state => state['comment']?.isLoading,
  state => state['diagramComment']?.isLoading,
  (commentsLoading: boolean, diagramCommentsLoading: boolean) => commentsLoading || diagramCommentsLoading
);
